<template>
  <v-container class="d-flex flex-column align-center justify-center pt-10 pb-10">
    <div style="width: 100%; max-width: 600px;">
      <v-card outlined>
        <v-card-title>Seu plano</v-card-title>
        <v-divider></v-divider>
        <div class="ma-4">
          <div class="d-flex align-center justify-space-between">
            <div class="d-flex flex-column" style="line-height: 1.2;">
              <span>Plano anual</span>
              <span class="font-weight-bold teal--text text--accent-4" style="font-size: 2em;">{{plan.name}}</span>
              <span class="font-weight-bold">com {{users}} usuário{{users > 1 ? 's' : ''}}</span>
            </div>
            <div class="d-flex flex-column align-end">
              <v-select
                outlined
                :items="options"
                v-model="installments"
                hide-details
                style="max-width: 180px; width: 100%;"
                label="Forma de pagamento"
              ></v-select>
              <span v-if="coupon" class="caption mt-2">(Cupom de {{coupon.value}}% aplicado)</span>
              <span v-else class="blue--text pointer caption mt-3" @click="dialogCoupon = true">Informar cupom de desconto</span>
            </div>
          </div>
        </div>
      </v-card>
      <v-card outlined class="mt-3">
        <v-card-title>Seus dados de cobrança</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div class="font-italic text-center">*Os dados abaixo são necessários para emitirmos sua nota fiscal.*</div>
          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-subheader>Dados pessoais</v-subheader>
            <v-row>
              <v-col cols="12" sm="5">
                <v-select
                  label="Tipo de pessoa"
                  :items="[{ name: 'Pessoa Física', value: 'PF' }, { name: 'Pessoa Jurídica', value: 'PJ' }]"
                  outlined
                  v-model="payer.type"
                  item-text="name"
                  item-value="value"
                  dense
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="7">
                <v-text-field
                  :label="payer.type === 'PF' ? 'CPF' : 'CNPJ'"
                  v-model="payer.cpf_cnpj"
                  hide-details="auto"
                  outlined
                  dense
                  v-mask="['###.###.###-##', '##.###.###/####-##']"
                  :rules="[v => !!v || `O ${payer.type === 'PF' ? 'CPF' : 'CNPJ'} é obrigatório`]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              class="mt-2"
              label="Nome"
              v-model="payer.name"
              hide-details
              outlined
              dense
              :rules="[v => !!v || `O nome é obrigatório`]"
              required
            ></v-text-field>
            <v-subheader class="mt-4">Informações de contato</v-subheader>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  type="tel"
                  label="Telefone de contato"
                  v-model="payer.phone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  hide-details="auto"
                  outlined
                  :rules="[v => !!v || `O telefone é obrigatório`]"
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  type="email"
                  label="Email de contato"
                  v-model="payer.email"
                  hide-details="auto"
                  :rules="[v => !!v || `O email é obrigatório`]"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-subheader>Endereço de cobrança</v-subheader>
            <v-row>
              <v-col cols="12" sm="8">
                <v-text-field
                  label="Rua"
                  v-model="payer.address.street"
                  hide-details="auto"
                  outlined
                  :rules="[v => !!v || `Insira a rua`]"
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  type="number"
                  label="Número"
                  v-model="payer.address.number"
                  hide-details="auto"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Complemento"
                  v-model="payer.address.complement"
                  hide-details="auto"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="CEP"
                  v-model="payer.address.zip_code"
                  hide-details="auto"
                  v-mask="`#####-###`"
                  :rules="[v => !!v || `Insira o CEP`]"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-text-field
                  label="Bairro"
                  v-model="payer.address.district"
                  hide-details="auto"
                  :rules="[v => !!v || `Insira o bairro`]"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Cidade"
                  v-model="payer.address.city"
                  hide-details="auto"
                  :rules="[v => !!v || `Insira a cidade`]"
                  outlined
                  dense
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4">
                <v-autocomplete
                  :items="states"
                  item-value="sigla"
                  item-text="nome"
                  label="Estado"
                  v-model="payer.address.state"
                  hide-details="auto"
                  outlined
                  :rules="[v => !!v || `Selecione o estado`]"
                  dense
                  required
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
      <div class="mt-3 mb-10">
        <v-btn depressed block color="secondary" @click="confirm()" :loading="loading">Prosseguir para o pagamento</v-btn>
      </div>
    </div>

    <v-dialog v-model="dialogCoupon" width="450">
      <v-card outlined>
        <v-card-title>Cupom</v-card-title>
        <v-card-text class="mt-3">
          <div class="d-flex align-center">
            <v-text-field
              outlined
              label="Digite o código seu cupom"
              hide-details
              v-model="textCoupon"
              dense
              @keypress.enter="applyCoupon()"
            ></v-text-field>
            <v-btn class="ml-2" color="teal accent-4" :loading="loadingCoupon" @click="applyCoupon()" depressed dark>aplicar</v-btn>
          </div>
          <div class="mt-3 text-center font-weight-bold red--text" v-if="couponError">Este cupom não existe ou já expirou seu prazo de utilização.</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import CouponService from '@/services/CouponService'

export default {
  props: ['plan', 'users'],
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    options () {
      const monthly = (this.plan.monthly_price / 100) * 12
      let userAmount = 0

      if (this.plan.max_users < this.users) {
        userAmount = (this.users - this.plan.max_users) * 97
      }

      const options = [{
        text: `1x de ${this.$options.filters.currency(this.getDiscount((this.plan.annual_price / 100) + userAmount))}`,
        value: 1
      }]

      for (let i = 2; i <= 12; i++) {
        options.push({
          text: `${i}x de ${this.$options.filters.currency(this.getDiscount((monthly + userAmount) / i))}`,
          value: i
        })
      }

      return options
    }
  },
  data () {
    return {
      lazy: false,
      loading: false,
      valid: false,
      installments: 1,
      coupon: null,
      dialogCoupon: false,
      loadingCoupon: false,
      textCoupon: null,
      activeCoupon: true,
      modalCoupon: false,
      couponError: false,
      payer: {
        type: 'PF',
        name: '',
        email: '',
        address: {}
      },
      states: [
        {"nome": "Acre", "sigla": "AC"},
        {"nome": "Alagoas", "sigla": "AL"},
        {"nome": "Amapá", "sigla": "AP"},
        {"nome": "Amazonas", "sigla": "AM"},
        {"nome": "Bahia", "sigla": "BA"},
        {"nome": "Ceará", "sigla": "CE"},
        {"nome": "Distrito Federal", "sigla": "DF"},
        {"nome": "Espírito Santo", "sigla": "ES"},
        {"nome": "Goiás", "sigla": "GO"},
        {"nome": "Maranhão", "sigla": "MA"},
        {"nome": "Mato Grosso", "sigla": "MT"},
        {"nome": "Mato Grosso do Sul", "sigla": "MS"},
        {"nome": "Minas Gerais", "sigla": "MG"},
        {"nome": "Pará", "sigla": "PA"},
        {"nome": "Paraíba", "sigla": "PB"},
        {"nome": "Paraná", "sigla": "PR"},
        {"nome": "Pernambuco", "sigla": "PE"},
        {"nome": "Piauí", "sigla": "PI"},
        {"nome": "Rio de Janeiro", "sigla": "RJ"},
        {"nome": "Rio Grande do Norte", "sigla": "RN"},
        {"nome": "Rio Grande do Sul", "sigla": "RS"},
        {"nome": "Rondônia", "sigla": "RO"},
        {"nome": "Roraima", "sigla": "RR"},
        {"nome": "Santa Catarina", "sigla": "SC"},
        {"nome": "São Paulo", "sigla": "SP"},
        {"nome": "Sergipe", "sigla": "SE"},
        {"nome": "Tocantins", "sigla": "TO"}
      ]
    }
  },
  watch: {
    user: {
      immediate: true,
      handler: function (user) {
        this.payer = user.payer || { type: 'PF', name: this.user.name, email: this.user.email, address: {} }
      }
    },
    textCoupon: {
      immediate: true,
      handler: function (coupon) {
        this.$emit('coupon', (coupon || '').toUpperCase())
      }
    }
  },
  methods: {
    async applyCoupon () {
      if (!this.textCoupon) {
        return false
      }

      this.loadingCoupon = true
      try {
        this.coupon = await CouponService.show(this.textCoupon)
        this.dialogCoupon = false
      } catch (e) {
        this.couponError = true
      } 
      this.loadingCoupon = false
    },
    async confirm () {
      if (!this.$refs.form.validate()) {
        return false
      }

      this.loading = true
      try {
        await this.$store.dispatch('auth/update', {
          payer: this.payer
        })
    
        this.$emit('confirm', this.installments)
      } catch (e) {
        console.error(e)
        alert('Oops! Ocorreu um erro ao salvar suas informações. Por favor, certifique-se que todos os campos tenhma sido respondidos corretamente.')
      }

      this.loading = false
    },
    getDiscount (amount) {
      return this.coupon ? amount - (amount * (this.coupon.value / 100)) : amount
    }
  }
}
</script>
